import React from 'react';
import { Layout, Image, ConfigProvider } from 'antd';
import './App.css';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom';
import { TFunction } from './types';
import { DefaultLayout } from 'components/DefaultLayout';
import svSE from 'antd/es/locale/sv_SE';
import routes from 'routes';
import Intercom from '@intercom/messenger-js-sdk';
import { AnalyticsTracker } from 'components/AnalyticsTracker';
import { initAnalytics } from 'analytics/ga4';

initAnalytics();

function App() {

  const { t }: TFunction = useTranslation();


	console.log(process.env.REACT_APP_RUN_INTERCOM);
	
	if (process.env.REACT_APP_RUN_INTERCOM == "true") {

		Intercom({
			app_id: 'qek7c8xo',
		});

	}
	

  return (
    <ConfigProvider
      locale={svSE}
      theme={{
        token: {
          fontFamily: 'Jakarta, sans-serif',
        },
        components: {
          Button: {
            colorPrimary: '#4a4d4e',
            colorPrimaryHover: '#5c5f60',
            colorPrimaryActive: '#3a3c3d',
          },
        },
      }}
    >
			<Router basename="/">
				<AnalyticsTracker />
				<DefaultLayout>
					{routes}
				</DefaultLayout>
			</Router>
		</ConfigProvider>
  );
}

export default App;
